import {
  BALANCE_SHEET,
  PROFIT_LOSS_STATEMENT,
} from "../../utils/Stringconstant";
import { tolerantDiff } from "../../utils/helperFunction";

const returnDataForEachYear = (rowNo, colNo, sheetData, unit) => {
  // console.log("====", rowNo, colNo, sheetData[rowNo], sheetData[rowNo].length);
  // console.log("====rownO", sheetData[rowNo][colNo]);
  return unit ? sheetData[rowNo][colNo] * unit : sheetData[rowNo][colNo];
};

const formattedYearInAuditSheet = (dateString, boxName) => {
  if (boxName === BALANCE_SHEET) {
    const match = dateString.match(/(\d{2})-(\w{3})-(\d{2})/);

    if (match) {
      const year = match[3];
      return `20${year}`;
    }
  }
  if (boxName === PROFIT_LOSS_STATEMENT) {
    const match = dateString.match(/(\d{4})-(\d{2})/);
    if (match) {
      const year = match[2];
      return `20${year}`;
    }
  }
  return null;
};

// format balance sheet data for sending to server.
export const balanceSheetReqBody = (balanceSheetData, unit = null) => {
  const firstRow = balanceSheetData[0];
  const yearWiseData = {};
  for (let i = firstRow.length - 1; i >= 1; i--) {
    const perYearData = {
      assets: {
        nonCurrentAssets: {
          propertyPlantAndEquipment: returnDataForEachYear(
            2,
            i,
            balanceSheetData,
            unit
          ),

          rightOfUseAssets: returnDataForEachYear(3, i, balanceSheetData, unit),

          capitalWorkInProgress: returnDataForEachYear(
            4,
            i,
            balanceSheetData,
            unit
          ),

          investmentProperties: returnDataForEachYear(
            5,
            i,
            balanceSheetData,
            unit
          ),

          goodwill: returnDataForEachYear(6, i, balanceSheetData, unit),

          otherIntangibleAssets: returnDataForEachYear(
            7,
            i,
            balanceSheetData,
            unit
          ),

          intangibleAssetsUnderDevelopment: returnDataForEachYear(
            8,
            i,
            balanceSheetData,
            unit
          ),

          biologicalAssetsOtherThanBearerPlants: returnDataForEachYear(
            9,
            i,
            balanceSheetData,
            unit
          ),

          financialAssets: {
            investments: returnDataForEachYear(12, i, balanceSheetData, unit),

            tradeReceivables: returnDataForEachYear(
              13,
              i,
              balanceSheetData,
              unit
            ),

            loans: returnDataForEachYear(14, i, balanceSheetData, unit),

            otherFinancialAssets: returnDataForEachYear(
              15,
              i,
              balanceSheetData,
              unit
            ),
          },
          deferredTaxAssets: returnDataForEachYear(
            17,
            i,
            balanceSheetData,
            unit
          ),

          otherNonCurrentAssets: returnDataForEachYear(
            18,
            i,
            balanceSheetData,
            unit
          ),

          subTotal: returnDataForEachYear(20, i, balanceSheetData, unit),
        },
        currentAssets: {
          inventories: returnDataForEachYear(23, i, balanceSheetData, unit),

          financialAssets: {
            investments: returnDataForEachYear(25, i, balanceSheetData, unit),

            tradeReceivables: returnDataForEachYear(
              26,
              i,
              balanceSheetData,
              unit
            ),

            cashAndCashEquivalents: returnDataForEachYear(
              27,
              i,
              balanceSheetData,
              unit
            ),

            bankBalancesOtherThan32: returnDataForEachYear(
              28,
              i,
              balanceSheetData,
              unit
            ),

            loans: returnDataForEachYear(29, i, balanceSheetData, unit),

            otherFinancialAssets: returnDataForEachYear(
              30,
              i,
              balanceSheetData,
              unit
            ),
          },
          currentTaxAssets: returnDataForEachYear(
            32,
            i,
            balanceSheetData,
            unit
          ),

          otherCurrentAssets: returnDataForEachYear(
            33,
            i,
            balanceSheetData,
            unit
          ),

          subTotal: returnDataForEachYear(35, i, balanceSheetData, unit),
        },
        nonCurrentAssetsClassifiedAsHeldForSale: returnDataForEachYear(
          37,
          i,
          balanceSheetData,
          unit
        ),

        totalAssets: returnDataForEachYear(39, i, balanceSheetData, unit),
      },
      equityAndLiabilities: {
        equity: {
          equityShareCapital: returnDataForEachYear(
            45,
            i,
            balanceSheetData,
            unit
          ),

          otherEquity: returnDataForEachYear(46, i, balanceSheetData, unit),

          totalEquity: returnDataForEachYear(47, i, balanceSheetData, unit),
        },
        liabilities: {
          nonCurrentLiabilities: {
            financialLiabilities: {
              borrowings: returnDataForEachYear(52, i, balanceSheetData, unit),

              tradePayable: returnDataForEachYear(
                53,
                i,
                balanceSheetData,
                unit
              ),

              otherFinancialLiabilities: returnDataForEachYear(
                54,
                i,
                balanceSheetData,
                unit
              ),
            },
            provisions: returnDataForEachYear(56, i, balanceSheetData, unit),

            deferredTaxLiabilities: returnDataForEachYear(
              57,
              i,
              balanceSheetData,
              unit
            ),

            otherNonCurrentLiabilities: returnDataForEachYear(
              58,
              i,
              balanceSheetData,
              unit
            ),

            totalNonCurrentLiabilities: returnDataForEachYear(
              60,
              i,
              balanceSheetData,
              unit
            ),
          },
          currentLiabilities: {
            financialLiabilities: {
              borrowings: returnDataForEachYear(64, i, balanceSheetData, unit),

              tradePayables: returnDataForEachYear(
                65,
                i,
                balanceSheetData,
                unit
              ),

              otherFinancialLiabilities: returnDataForEachYear(
                66,
                i,
                balanceSheetData,
                unit
              ),
            },
            provisions: returnDataForEachYear(68, i, balanceSheetData, unit),

            otherCurrentLiabilities: returnDataForEachYear(
              69,
              i,
              balanceSheetData,
              unit
            ),

            currentTaxLiabilities: returnDataForEachYear(
              70,
              i,
              balanceSheetData,
              unit
            ),

            totalCurrentLiabilities: returnDataForEachYear(
              72,
              i,
              balanceSheetData,
              unit
            ),
          },
        },
        totalEquityAndLiabilities: returnDataForEachYear(
          74,
          i,
          balanceSheetData,
          unit
        ),
      },
    };
    yearWiseData[firstRow[i]] = perYearData;
  }
  return yearWiseData;
};

// format profit loss sheet data for sending to server.
export const IncomeStatReqBody = (profitLossSheetData, unit = null) => {
  const firstRow = profitLossSheetData[0];
  const yearWiseData = {};
  for (let i = firstRow.length - 1; i >= 1; i--) {
    const perYearData = {
      continuingOperations: {
        revenueFromOperations: returnDataForEachYear(
          2,
          i,
          profitLossSheetData,
          unit
        ),
        otherIncome: returnDataForEachYear(3, i, profitLossSheetData, unit),
        totalRevenue: returnDataForEachYear(4, i, profitLossSheetData, unit),
      },

      expenses: {
        costOfMaterialsConsumed: returnDataForEachYear(
          7,
          i,
          profitLossSheetData,
          unit
        ),

        purchasesOfStockInTrade: returnDataForEachYear(
          8,
          i,
          profitLossSheetData,
          unit
        ),

        changesInStockOfFinishedGoodsWorkInProgressAndStockInTrade:
          returnDataForEachYear(9, i, profitLossSheetData, unit),

        employeeBenefitExpense: returnDataForEachYear(
          10,
          i,
          profitLossSheetData,
          unit
        ),

        financeCosts: returnDataForEachYear(11, i, profitLossSheetData, unit),

        depreciationAndAmortisationExpense: returnDataForEachYear(
          12,
          i,
          profitLossSheetData,
          unit
        ),

        impairmentExpensesLosses: returnDataForEachYear(
          13,
          i,
          profitLossSheetData,
          unit
        ),

        otherExpenses: returnDataForEachYear(14, i, profitLossSheetData, unit),

        totalExpenses: returnDataForEachYear(15, i, profitLossSheetData, unit),
      },

      profitOrLossBeforeExceptionalItemsAndTax: returnDataForEachYear(
        17,
        i,
        profitLossSheetData,
        unit
      ),

      exceptionalItems: returnDataForEachYear(18, i, profitLossSheetData, unit),

      profitOrLossBeforeTax: returnDataForEachYear(
        19,
        i,
        profitLossSheetData,
        unit
      ),

      taxExpense: {
        currentTax: returnDataForEachYear(22, i, profitLossSheetData, unit),

        deferredTax: returnDataForEachYear(23, i, profitLossSheetData, unit),

        totalTaxExpense: returnDataForEachYear(
          24,
          i,
          profitLossSheetData,
          unit
        ),
      },

      profitOrLossAfterTaxFromContinuingOperations: returnDataForEachYear(
        26,
        i,
        profitLossSheetData,
        unit
      ),

      discontinuedOperations: {
        profitOrLossFromDiscontinuedOperations: returnDataForEachYear(
          29,
          i,
          profitLossSheetData,
          unit
        ),

        taxExpenseOfDiscontinuedOperations: returnDataForEachYear(
          30,
          i,
          profitLossSheetData,
          unit
        ),

        profitOrLossAfterTaxFromDiscontinuedOperations: returnDataForEachYear(
          32,
          i,
          profitLossSheetData,
          unit
        ),
      },
      profitOrLossForThePeriodContandDiscont: returnDataForEachYear(
        33,
        i,
        profitLossSheetData,
        unit
      ),

      otherComprehensiveIncome: {
        itemsThatWillNotBeReclassifiedToProfitOrLoss: {
          changesInRevaluationSurplus: returnDataForEachYear(
            37,
            i,
            profitLossSheetData,
            unit
          ),

          remeasurementsOfTheDefinedBenefitLiabilitiesOrAsset:
            returnDataForEachYear(38, i, profitLossSheetData, unit),

          equityInstrumentsThroughOtherComprehensiveIncome:
            returnDataForEachYear(39, i, profitLossSheetData, unit),

          fairValueChangesRelatingToOwnCreditRisk: returnDataForEachYear(
            40,
            i,
            profitLossSheetData,
            unit
          ),

          others: returnDataForEachYear(41, i, profitLossSheetData, unit),

          incomeTaxRelatingToItemsThatWillNotBeReclassifiedToProfitOrLoss:
            returnDataForEachYear(42, i, profitLossSheetData, unit),
        },

        itemsThatMayBeReclassifiedToProfitOrLoss: {
          exchangeDifferencesInTranslatingTheFinancialStatementsOfForeignOperations:
            returnDataForEachYear(45, i, profitLossSheetData, unit),

          debtInstrumentsThroughOtherComprehensiveIncome: returnDataForEachYear(
            46,
            i,
            profitLossSheetData,
            unit
          ),

          effectivePortionOfGainsAndLossOnDesignatedPortionOfHedgingInstrumentsInACashFlowHedge:
            returnDataForEachYear(47, i, profitLossSheetData, unit),

          shareOfOtherComprehensiveIncomeOfEquityAccountedInvestees:
            returnDataForEachYear(48, i, profitLossSheetData, unit),

          others: returnDataForEachYear(49, i, profitLossSheetData, unit),

          incomeTaxOnItemsThatMayBeReclassifiedToProfitOrLoss:
            returnDataForEachYear(51, i, profitLossSheetData, unit),
        },
      },

      totalComprehensiveIncomeForThePeriod: returnDataForEachYear(
        53,
        i,
        profitLossSheetData,
        unit
      ),

      earningsPerEquityShareForContinuingOperation: {
        basic: returnDataForEachYear(56, i, profitLossSheetData, unit),

        diluted: returnDataForEachYear(57, i, profitLossSheetData, unit),
      },

      earningsPerEquityShareForDiscontinuedOperation: {
        basic: returnDataForEachYear(60, i, profitLossSheetData, unit),

        diluted: returnDataForEachYear(61, i, profitLossSheetData, unit),
      },

      earningsPerEquityShareForContinuingAndDiscontinuedOperations: {
        basic: returnDataForEachYear(64, i, profitLossSheetData, unit),

        diluted: returnDataForEachYear(65, i, profitLossSheetData, unit),
      },
    };
    yearWiseData[firstRow[i]] = perYearData;
  }
  return yearWiseData;
};

/**
 * Formats and returns a 2D array by filtering valid columns and modifying year values.
 *
 * @param {Array<Array>} sheetData - The 2D array of sheet data.
 * @param {string} boxName - The name of the box being processed.
 * @return {Array<Array>} formattedResult - The formatted 2D array with valid columns and modified year values.
 */
export const returnFormattedArr = (sheetData, boxName) => {
  const result = [];
  const validCols = [0];
  const firstValue = sheetData[0][0];
  const allYears = [];

  sheetData[0] = sheetData[0]
    .slice(1)
    .filter((val, index) => {
      if (!val) {
        return false;
      }
      validCols.push(index + 1);
      return true;
    })
    .map((val) => {
      const year = formattedYearInAuditSheet(val, boxName);
      allYears.push(year);
      return year;
    });
  result.push([firstValue, ...sheetData[0]]);

  sheetData.slice(1).forEach((r) => {
    const row = r.filter((val, i) => validCols.includes(i));
    result.push(row);
  });
  return { result, allYears };
};

/**
 * Returns array of yearwise data(actual and expected) for all formula rows.
 *
 * @param {Object} param - The request body containing financial data.
 * @return {Array<Object>} - yearWiseData - year, actual, expected value of formula row metrics for each year
 */
const returnActualAndDesiredValuesForBalanceSheet = (sheetData) => {
  let yearWiseData = [];
  // for (let i = 0; i < sheetData.length; i++) {
  for (let year in sheetData) {
    const param = sheetData[year];
    const {
      assets: {
        nonCurrentAssets,
        currentAssets,
        totalAssets,
        nonCurrentAssetsClassifiedAsHeldForSale,
      },
      equityAndLiabilities: {
        equity,
        liabilities: { nonCurrentLiabilities, currentLiabilities },
        totalEquityAndLiabilities: actualResultTotalEquityAndLiabilities,
      },
    } = param;

    const {
      biologicalAssetsOtherThanBearerPlants,
      capitalWorkInProgress,
      deferredTaxAssets,
      financialAssets: {
        investments: nonCurrentInvestments,
        loans: nonCurrentLoans,
        otherFinancialAssets: nonCurrentotherFinancialAssets,
        tradeReceivables: nonCurrentTradeReceivables,
      },
      goodwill,
      intangibleAssetsUnderDevelopment,
      investmentProperties,
      otherNonCurrentAssets,
      otherIntangibleAssets,
      propertyPlantAndEquipment,
      rightOfUseAssets,
      subTotal: actualResultNonCurrAssets,
    } = nonCurrentAssets;

    const {
      subTotal: actualResultCurrAssets,
      currentTaxAssets,
      financialAssets: {
        bankBalancesOtherThan32,
        cashAndCashEquivalents,
        investments: currentInvestments,
        loans: currentLoans,
        otherFinancialAssets: currentotherFinancialAssets,
        tradeReceivables: currenttradeReceivables,
      },
      inventories,
      otherCurrentAssets,
    } = currentAssets;

    const {
      equityShareCapital,
      otherEquity,
      totalEquity: actualResultTotalEquity,
    } = equity;

    const {
      totalNonCurrentLiabilities: actualResultNonCurrLiabiites,
      deferredTaxLiabilities,
      financialLiabilities: {
        borrowings: nonCurrLiabilitiesBorrowings,
        otherFinancialLiabilities: nonCurrLiabilitiesOtherFinanacial,
        tradePayable: nonCurrLiabilitiesTradePayable,
      },
      otherNonCurrentLiabilities,
      provisions: nonCurrLiabilitiesProvisions,
    } = nonCurrentLiabilities;

    const {
      totalCurrentLiabilities: actualResultCurrLiabilities,
      currentTaxLiabilities,
      financialLiabilities: {
        borrowings: currLiabilitiesBorrowings,
        otherFinancialLiabilities: currLiabilitiesOtherFinanacial,
        tradePayables: currLiabilitiesTradePayable,
      },
      otherCurrentLiabilities,
      provisions: currLiabilitiesProvisions,
    } = currentLiabilities;

    const yearWise = {
      currentAssets: {
        actualResult: actualResultCurrAssets,
        expected:
          currentTaxAssets +
          bankBalancesOtherThan32 +
          cashAndCashEquivalents +
          currentInvestments +
          currentLoans +
          currentotherFinancialAssets +
          currenttradeReceivables +
          inventories +
          otherCurrentAssets,
      },
      nonCurrentAssets: {
        actualResult: actualResultNonCurrAssets,
        expected:
          biologicalAssetsOtherThanBearerPlants +
          capitalWorkInProgress +
          deferredTaxAssets +
          nonCurrentInvestments +
          nonCurrentLoans +
          nonCurrentotherFinancialAssets +
          nonCurrentTradeReceivables +
          goodwill +
          intangibleAssetsUnderDevelopment +
          investmentProperties +
          otherNonCurrentAssets +
          otherIntangibleAssets +
          propertyPlantAndEquipment +
          rightOfUseAssets,
      },
      totalAssets: {
        actualResult: totalAssets,
        expected:
          actualResultCurrAssets +
          actualResultNonCurrAssets +
          nonCurrentAssetsClassifiedAsHeldForSale,
      },
      equity: {
        actualResult: actualResultTotalEquity,
        expected: equityShareCapital + otherEquity,
      },
      nonCurrentLiabilities: {
        actualResult: actualResultNonCurrLiabiites,
        expected:
          deferredTaxLiabilities +
          nonCurrLiabilitiesBorrowings +
          nonCurrLiabilitiesOtherFinanacial +
          nonCurrLiabilitiesTradePayable +
          otherNonCurrentLiabilities +
          nonCurrLiabilitiesProvisions,
      },
      currentLiabilities: {
        actualResult: actualResultCurrLiabilities,
        expected:
          currentTaxLiabilities +
          currLiabilitiesBorrowings +
          currLiabilitiesOtherFinanacial +
          currLiabilitiesTradePayable +
          otherCurrentLiabilities +
          currLiabilitiesProvisions,
      },
      totalEquityAndLiabilities: {
        actualResult: actualResultTotalEquityAndLiabilities,
        expected:
          actualResultCurrLiabilities +
          actualResultNonCurrLiabiites +
          actualResultTotalEquity,
      },
      balancedSheet: {
        actualResult: actualResultTotalEquityAndLiabilities,
        expected: totalAssets,
      },
      year: year
    };
    yearWiseData.push(yearWise);
  }
  return yearWiseData;
};

const returnActualAndDesiredValuesForPlSheet = (sheetData) => {
  let yearWiseData = [];
  for (let year in sheetData) {
    const param = sheetData[year];
    const {
      continuingOperations,
      expenses,
      profitOrLossBeforeExceptionalItemsAndTax,
      profitOrLossBeforeTax,
      exceptionalItems,
      taxExpense,
      profitOrLossAfterTaxFromContinuingOperations,
      profitOrLossForThePeriodContandDiscont,
      discontinuedOperations: {
        profitOrLossAfterTaxFromDiscontinuedOperations,
        profitOrLossFromDiscontinuedOperations,
        taxExpenseOfDiscontinuedOperations,
      },
      totalComprehensiveIncomeForThePeriod,
      otherComprehensiveIncome: {
        itemsThatMayBeReclassifiedToProfitOrLoss,
        itemsThatWillNotBeReclassifiedToProfitOrLoss,
      },
    } = param;

    const {
      totalRevenue: actualResultTotalRevenue,
      revenueFromOperations,
      otherIncome,
    } = continuingOperations;

    const {
      totalExpenses: actualResultTotalExpenses,
      changesInStockOfFinishedGoodsWorkInProgressAndStockInTrade,
      costOfMaterialsConsumed,
      depreciationAndAmortisationExpense,
      employeeBenefitExpense,
      financeCosts,
      impairmentExpensesLosses,
      otherExpenses,
      purchasesOfStockInTrade,
    } = expenses;

    const {
      totalTaxExpense: actualResultTotalTaxExpense,
      currentTax,
      deferredTax,
    } = taxExpense;

    const {
      debtInstrumentsThroughOtherComprehensiveIncome,
      effectivePortionOfGainsAndLossOnDesignatedPortionOfHedgingInstrumentsInACashFlowHedge,
      exchangeDifferencesInTranslatingTheFinancialStatementsOfForeignOperations,
      incomeTaxOnItemsThatMayBeReclassifiedToProfitOrLoss,
      others: othersItemsThatMayBeReclassified,
      shareOfOtherComprehensiveIncomeOfEquityAccountedInvestees,
    } = itemsThatMayBeReclassifiedToProfitOrLoss;

    const {
      changesInRevaluationSurplus,
      equityInstrumentsThroughOtherComprehensiveIncome,
      fairValueChangesRelatingToOwnCreditRisk,
      incomeTaxRelatingToItemsThatWillNotBeReclassifiedToProfitOrLoss,
      others: otherItemsThatWillNotBeReclassified,
      remeasurementsOfTheDefinedBenefitLiabilitiesOrAsset,
    } = itemsThatWillNotBeReclassifiedToProfitOrLoss;

    const yearWise = {
      continuingOperations: {
        actualResult: actualResultTotalRevenue,
        expected: revenueFromOperations + otherIncome,
      },
      expenses: {
        actualResult: actualResultTotalExpenses,
        expected:
          changesInStockOfFinishedGoodsWorkInProgressAndStockInTrade +
          costOfMaterialsConsumed +
          depreciationAndAmortisationExpense +
          employeeBenefitExpense +
          financeCosts +
          impairmentExpensesLosses +
          otherExpenses +
          purchasesOfStockInTrade,
      },
      profitOrLossBeforeExceptionalItemsAndTax: {
        actualResult: profitOrLossBeforeExceptionalItemsAndTax,
        expected: actualResultTotalRevenue - actualResultTotalExpenses,
      },
      profitOrLossBeforeTax: {
        actualResult: profitOrLossBeforeTax,
        expected: profitOrLossBeforeExceptionalItemsAndTax - exceptionalItems,
      },
      taxExpense: {
        actualResult: actualResultTotalTaxExpense,
        expected: currentTax + deferredTax,
      },
      profitOrLossAfterTaxFromContinuingOperations: {
        actualResult: profitOrLossAfterTaxFromContinuingOperations,
        expected: profitOrLossBeforeTax - actualResultTotalTaxExpense,
      },
      profitOrLossAfterTaxFromDiscontinuedOperations: {
        actualResult: profitOrLossAfterTaxFromDiscontinuedOperations,
        expected:
          profitOrLossFromDiscontinuedOperations -
          taxExpenseOfDiscontinuedOperations,
      },
      profitOrLossForThePeriodContandDiscont: {
        actualResult: profitOrLossForThePeriodContandDiscont,
        expected:
          profitOrLossAfterTaxFromContinuingOperations +
          profitOrLossAfterTaxFromDiscontinuedOperations,
      },
      totalComprehensiveIncomeForThePeriod: {
        actualResult: totalComprehensiveIncomeForThePeriod,
        expected:
          profitOrLossForThePeriodContandDiscont +
          debtInstrumentsThroughOtherComprehensiveIncome +
          effectivePortionOfGainsAndLossOnDesignatedPortionOfHedgingInstrumentsInACashFlowHedge +
          exchangeDifferencesInTranslatingTheFinancialStatementsOfForeignOperations +
          incomeTaxOnItemsThatMayBeReclassifiedToProfitOrLoss +
          othersItemsThatMayBeReclassified +
          shareOfOtherComprehensiveIncomeOfEquityAccountedInvestees +
          changesInRevaluationSurplus +
          equityInstrumentsThroughOtherComprehensiveIncome +
          fairValueChangesRelatingToOwnCreditRisk +
          incomeTaxRelatingToItemsThatWillNotBeReclassifiedToProfitOrLoss +
          otherItemsThatWillNotBeReclassified +
          remeasurementsOfTheDefinedBenefitLiabilitiesOrAsset,
      },
    };
    yearWiseData.push(yearWise);
  }
  return yearWiseData;
};

// validate formulas for balance sheet and profit loss statement for each year and atleast 3 years of audit data
export const isFormulasAndMinEnteredAuditValidated = (
  param,
  boxName
) => {
  const yearWiseData =
    boxName === BALANCE_SHEET
      ? returnActualAndDesiredValuesForBalanceSheet(param)
      : returnActualAndDesiredValuesForPlSheet(param);
  const allKeys = Object.keys(yearWiseData[0]).reduce((acc, curr) => {
    if (curr !== "year") {
      acc[curr] = 0;
    }
    return acc;
  }, {});

  for (const yearData of yearWiseData) {
    for (const section in yearData) {
      if (section !== "year") {
        const actualResult = yearData[section].actualResult;
        const expectedResult = yearData[section].expected;
        if (actualResult) {
          allKeys[section]++;
        }

        if (!tolerantDiff(actualResult, expectedResult)) {
          if (section === "balancedSheet") {
            throw new Error(
              `Balanced sheet is not balanced in ${yearData.year}`
            );
          }
          throw new Error(
            `Please verify formula with ${section} in ${yearData.year}`
          );
        }
      }
    }
  }
  validateMinAuditDataAllowed(allKeys);
};

// validation for atleast 3 years of audit data
const validateMinAuditDataAllowed = (currentUploadOnly, formulaRows) => {
  for (const key in formulaRows) {
    if (
      !keysExemptedFromMinYears.includes(key) &&
      ((currentUploadOnly && formulaRows[key] >= 1) || formulaRows[key] < 3)
    ) {
      throw new Error(
        `Please verify atleast 3 years of audit data is entered for ${key}`
      );
    }
  }
};

export const isAuditFormatValid = (arr1, arr2) => {
  // Check if the arrays have the same length
  if (arr1.length !== arr2.length) {
    return false;
  }

  // Iterate through the arrays and compare elements while ignoring \r\n
  for (let i = 0; i < arr1.length; i++) {
    const element1 = arr1[i];
    const element2 = arr2[i];

    // Normalize both elements by replacing \r\n with \n (if they are strings)
    const normalizedElement1 =
      typeof element1 === "string" ? element1.replace(/\r\n/g, "\n") : element1;
    const normalizedElement2 =
      typeof element2 === "string" ? element2.replace(/\r\n/g, "\n") : element2;

    // Compare the normalized elements
    if (normalizedElement1 !== normalizedElement2) {
      return false;
    }
  }

  // If all elements are equal, the arrays are equal
  return true;
};

const keysExemptedFromMinYears = [
  "balancedSheet",
  "profitOrLossAfterTaxFromDiscontinuedOperations",
  "taxExpense",
];


export const getColumnWiseDict = (keysHeader,rawData) => {
  const result = {};
  console.log("=====keysHeader", keysHeader);
  // Loop through the rest of the rows and map values to the keys
  result['Particulars'] = rawData.map((row) => row[0]);
  for (let i = 1; i < keysHeader.length; i++) {
    // Create an array for each column, starting from the second row onwards
    result[keysHeader[i]] = rawData.map((row) => row[i]);
  }

  return result;
}